import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import VehicleShowroomWorksStep from "./VehicleShowroomWorksStep/VehicleShowroomWorksStep";
import { useGetRouteState } from "../../utils/route.utils";
import { getJson } from "../../utils/json.utils";

export default function VehicleShowroomWorksAddPage({ editItem }) {
  const { data: existVehicle, redirectTo } = useGetRouteState();

  const id = editItem?.id ?? "";

  const editedVehicle = editItem?.attachment ? getJson(editItem.attachment) : "";

  const editInventoryBackPath = editedVehicle?.car?.sku
    ? `/stock-list/${editedVehicle?.car?.sku}/view`
    : "";

  const isLoading = false;

  const title = `${!!id ? "Edit" : "Add"} Showroom Works`;

  const backPath = redirectTo ?? editInventoryBackPath ?? "/stock-list";

  const breadCrumbs = [
    {
      name: "Showroom Works",
      link: backPath
    },
    {
      name: title ?? ""
    }
  ];

  return (
    <PageLayout title={title} breadCrumbs={breadCrumbs}>
      {<Loading loading={isLoading} />}
      {!isLoading && (
        <VehicleShowroomWorksStep
          title={title}
          editItem={editItem}
          existVehicle={existVehicle}
          redirectTo={backPath}
        />
      )}
    </PageLayout>
  );
}
